import component from './property-title.js';
export default component;
